import { Const } from "../../Const";
import { SubmitKey } from "./SubmitKey";
export class SubmitBase {
    constructor() {
        this.clipInfoID = -1;
        this.blendType = -1;
        this._id = 0;
        this._renderType = 0;
        this._key = new SubmitKey();
        this._startIdx = 0;
        this._numEle = 0;
        this._colorFiler = null;
        this.shaderValue = null;
        this._id = ++SubmitBase.ID;
    }
    static create(context, mesh, sv) {
        var o = new SubmitBase();
        o._mesh = mesh;
        o._key.clear();
        o._key.submitType = SubmitBase.KEY_DRAWTEXTURE;
        o._startIdx = mesh.indexNum * Const.INDEX_BYTES;
        o._numEle = 0;
        var blendType = context._nBlendType;
        o._key.blendShader = blendType;
        o.shaderValue = sv;
        o.material = context._material;
        o._colorFiler = context._colorFiler;
        return o;
    }
}
SubmitBase.KEY_ONCE = -1;
SubmitBase.KEY_FILLRECT = 1;
SubmitBase.KEY_DRAWTEXTURE = 2;
SubmitBase.KEY_VG = 3;
SubmitBase.KEY_TRIANGLES = 4;
SubmitBase.ID = 1;
SubmitBase.RENDERBASE = new SubmitBase();
